import Icon, { IconName } from "components/ui/Icon";
import UILabel from "components/ui/UILabel";
import { Theme } from "styled";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 24px 36px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 auto;

  background: ${(props) => props.theme.colors.secondary}40;
  border-radius: 24px;
`;

const ListItem = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  align-items: flex-start;
`;

const getIconStyles = (props: { $icon: string; theme: Theme }) => {
  switch (props.$icon) {
    case "plus":
      return `
        background: ${props.theme.colors.accent};
        color: ${props.theme.reverseColors.accent};
      `;
    case "minus":
      return `
        background: ${props.theme.colors.secondary};
        color: ${props.theme.reverseColors.secondary};
      `;
    default:
      return `
        background: ${props.theme.colors.primary};
        color: ${props.theme.reverseColors.primary};
      `;
  }
};

const IconWrapper = styled.div<{ $icon: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;

  background: ${(props) => props.theme.colors.accent};
  border-radius: 9999px;

  ${getIconStyles};

  svg {
    stroke: currentColor;
    stroke-width: 20px;
  }
`;

const ItemText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 auto;
  align-items: flex-start;
  padding-top: 2px;

  text-align: left;
`;

const ItemBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  opacity: 0.7;
`;

const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.primary}40;
  margin: 12px 0;
`;

const LINE_ITEMS: { icon: IconName; title: string; body: string }[] = [
  {
    icon: "plus",
    title: "Money coming in",
    body: "Earned, but unpaid wages",
  },
  {
    icon: "plus",
    title: "Money you already have",
    body: "Checking balance",
  },
  {
    icon: "minus",
    title: "Money leaving shortly",
    body: "Bills, savings, investing",
  },
];

const Calculator = () => {
  return (
    <Wrapper>
      {LINE_ITEMS.map((item) => (
        <ListItem key={item.title}>
          <IconWrapper $icon={item.icon}>
            <Icon name={item.icon} size="xs" />
          </IconWrapper>

          <ItemText>
            <UILabel.Large bold>{item.title}</UILabel.Large>
            <ItemBody>
              <UILabel.Medium>{item.body}</UILabel.Medium>
            </ItemBody>
          </ItemText>
        </ListItem>
      ))}

      <Divider />

      <ListItem>
        <IconWrapper $icon="equals">
          <Icon name="equals" size="xs" />
        </IconWrapper>

        <ItemText>
          <UILabel.Large bold>Safe to spend</UILabel.Large>
        </ItemText>
      </ListItem>
    </Wrapper>
  );
};

export default Calculator;
